/**
 * Canonical Key Offices for admin Announcements sidebar.
 * Announcements are stored as updates with type=announcement and category=officeId
 * so they appear on /offices/{slug}/announcements.
 */
export const KEY_OFFICES = [
  {
    slug: "registrar",
    id: "8bb63a5d82478e162e50b8f5",
    name: "Office of the Registrar",
    label: "Office of the Registrar",
  },
  {
    slug: "qec",
    id: "6897c0941db1e253cec5259a",
    name: "Quality Enhancement Cell (QEC)",
    label: "Quality Enhancement Cell (QEC)",
  },
  {
    slug: "oric",
    id: "6784b3229abb7aca1f52120e",
    name: "Directorate of ORIC",
    label: "Directorate of ORIC",
  },
  {
    slug: "external-linkages",
    id: "6c93d5fa2b3e4f6a8b9012c1",
    name: "Directorate of External Linkages",
    label: "Directorate of External Linkages",
  },
  {
    slug: "examination",
    id: "695cc2576e918734f5cd77e2",
    name: "Office of Controller of Examination",
    label: "Controller of Examination",
  },
  {
    slug: "pro",
    id: "678e0401ed9b336a0fca555d",
    name: "Public Relations Office",
    label: "Public Relations Office",
  },
  {
    slug: "student-affairs",
    id: "6b82c4e91a2f3d5e7f8091a1",
    name: "Directorate of Student Affairs",
    label: "Directorate of Student Affairs",
  },
  {
    slug: "it-services",
    id: "6a51b6dd21d7db8e31da818d",
    name: "Directorate of IT Services",
    label: "Directorate of IT Services",
  },
  {
    slug: "alumni",
    id: "6b82c4e91a2f3d5e7f8091a2",
    name: "Alumni",
    label: "Alumni",
  },
  {
    slug: "affiliated-colleges",
    id: "6c82c4e91a2f3d5e7f8091a3",
    name: "Affiliated Colleges",
    label: "Affiliated Colleges",
  },
  {
    slug: "sdc",
    id: "sdcoff000000000000000001",
    name: "Skills Development Center (SDC)",
    label: "Skills Development Center",
  },
  {
    slug: "navttc",
    id: "sdcoff000000000000000001",
    name: "NAVTTC Courses / Trainings",
    label: "NAVTTC Announcements",
  },
];

export function getKeyOfficeBySlug(slug) {
  return KEY_OFFICES.find((o) => o.slug === slug) || null;
}
